module.exports = __webpack_public_path__ + "img/bg-foodandbeverage.b9df0f4f.jpg";